import Vue from 'vue'
import Router from 'vue-router'

// 预约系统
import Application from '../pages/reserve/application.vue'   // 使用申请
import Questionnaire from '../pages/reserve/questionnaire/index.vue'   //问卷
import Answer from '../pages/reserve/answer/index.vue'   //答卷



Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/application',
      name: 'application',
      component: Application
    },
    {
      path: '/questionnaire',
      name: 'questionnaire',
      component: Questionnaire
    },  
    {
      path: '/answer',
      name: 'answer',
      component: Answer
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js